import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export function getPaginatorIntl(
  translate: TranslateService
): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();

  const setTranslations = () => {
    translate
      .get([
        'Items per page',
        'Next page',
        'Previous page',
        'First page',
        'Last page',
        'Page',
      ])
      .subscribe((translations) => {
        paginatorIntl.itemsPerPageLabel = translations['Items per page'];
        paginatorIntl.nextPageLabel = translations['Next page'];
        paginatorIntl.previousPageLabel = translations['Previous page'];
        paginatorIntl.firstPageLabel = translations['First page'];
        paginatorIntl.lastPageLabel = translations['Last page'];

        paginatorIntl.getRangeLabel = (
          page: number,
          pageSize: number,
          length: number
        ) => {
          if (length === 0 || pageSize === 0)
            return `${translations['Page']} 0 of 0`;
          const startIndex = page * pageSize;
          const endIndex = Math.min(startIndex + pageSize, length);
          return `${translations['Page']} ${page + 1} of ${Math.ceil(
            length / pageSize
          )}`;
        };

        paginatorIntl.changes.next();
      });
  };

  setTranslations();
  translate.onLangChange.subscribe(() => setTranslations());

  return paginatorIntl;
}
